// libraries.
import { useGoogleLogin, TokenResponse } from "@react-oauth/google";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CountryCode, getCountryCodeByEmail } from "@utils/country";
import { pathHomeReleaseNotes } from "@pages/HomePage/routes/routes.types";
import { pathHome } from "@routes/routes.types";

// styles.
import { ButtonGoogleHabi } from "./styles";

// slices.
import { useUserProfile } from "./user-slice/useUserProfile.hook";
import { useAuthMutation } from "@store/apiSlices/auth/auth";
import { setCountries, setCountry } from "./user-slice/userSlice";

export const ButtonGoogle = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [triggerAuth, { data, isSuccess, isLoading }] = useAuthMutation();

  const { updateUserProfile } = useUserProfile();

  const loginGoogle = useGoogleLogin({
    onError: (error) => {
      console.error("Google login error:", error);
    },
    onSuccess: async (tokenResponse: TokenResponse) => {
      try {
        const res = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          },
        );

        if (!res.ok) {
          throw new Error(`Failed to fetch user info: ${res.status}`);
        }

        const profile = await res.json();
        updateUserProfile({
          email: profile.email,
          familyName: profile.family_name,
          givenName: profile.given_name,
          googleId: profile.sub,
          imageUrl: profile.picture,
          name: profile.name,
        });
        const country = getCountryCodeByEmail(profile.email);
        if (!country) return;
        triggerAuth({ country, external: false, userId: profile.sub });
      } catch (e) {
        console.error("Error fetching user profile:", e);
      }
    },
  });

  useEffect(() => {
    if (isSuccess) {
      dispatch(setCountries(data?.countriesSelect || []));
      dispatch(setCountry(data?.countriesByUser[0] || ("" as CountryCode)));
      navigate(`${pathHome}/${pathHomeReleaseNotes}`);
    }
  }, [isSuccess, data, dispatch, navigate]);

  if (isLoading) {
    return (
      <ButtonGoogleHabi>
        <p className="ingresar">Cargando...</p>
      </ButtonGoogleHabi>
    );
  }

  return (
    <ButtonGoogleHabi onClick={() => loginGoogle()}>
      <p className="ingresar">Ingresar</p>
    </ButtonGoogleHabi>
  );
};
